<div class="order-details-container" *ngIf="orderWithDetails$ | async; let orderWithDetails">
  <div class="page-header-container">
    <div class="header-composed mb-3">
      <a (click)="navigateBack()" class="text-title-2 back-ref">
        {{(navigationState | navigatedFrom : 'Waste / Destructions' : '/inventory/inventory-destructions-history')?.name}}
      </a>
      <div class="text-title-2 header">
          {{orderWithDetails.nameOfDestruction?.toUpperCase()}}
      </div>
    </div>
  
    <div class="page-subheader" >
      <div class="inventory-details">
        <div class="label">Method of Waste / Destruction:</div>
        <div class="value">
          {{orderWithDetails?.methodOfDestruction}}
        </div>
      </div>
      <div class="inventory-details" *ngIf="orderWithDetails?.placeOfDestruction">
        <div class="label">Location:</div>
        <div class="value">
          {{orderWithDetails?.placeOfDestruction}}
        </div>
      </div>
    </div>
    <div class="inventory-details">
      <div class="label">Performed:</div>
      <div class="value">{{orderWithDetails?.createDate | formattedDate: 'MM d a, HH:mm'}}
      </div>
      <span class="vertical-divider"> | </span>
      <div class="label">Recorded:</div>
      <div class="value">
        {{orderWithDetails?.executorFirstName}}
        <ng-container>
          {{orderWithDetails?.executorLastName[0]}}.;
        </ng-container>
        {{orderWithDetails?.createDate | formattedDate: 'MM d a, HH:mm'}}
      </div>
      <span class="vertical-divider"> | </span>
      <div class="label">Witness:</div>
      <div class="value">
        {{orderWithDetails?.witnessFirstName}}
        <ng-container>
          {{orderWithDetails?.witnessLastName[0]}}.
        </ng-container>
      </div>
    </div>
    <div #buyerSupplier>
      <app-supplier-buyer-card class="block pt-3" *ngIf="orderWithDetails?.supplierDetails"
        [readOnly]="true"
        [data]="orderWithDetails?.supplierDetails">
      </app-supplier-buyer-card>
    </div>
  </div>
<div #fileAttachment>
  <app-file-attachment
    [files]="orderFiles$ | async"
    [fileTypes]="fileTypes"
    [requiresSignature]="true"
    (downloadFile)="downloadFile($event)"
    (saveFiles)="saveAttachmentsList($event)"
  >
  </app-file-attachment>
</div>
 
  <app-generic-table
        [ngStyle]="{'--table-height': calculateTableHeight()}"
        [data]="orderWithDetails?.orderLines" 
        [columns]="columns"
        [withDetailsOption]="false"
  ></app-generic-table>
</div>